module.exports = __webpack_public_path__ + "assets/img/cancel.65c82193.png";